const GOOGLE_ADS_PURCHASE_CONVERSION = 'AW-17797671666/RK0XCMLz888cEPLVy6ZC';

// Only call this once the API confirms the order is paid; transaction_id lets
// Google Ads de-duplicate if it is ever reported twice for the same order.
export const reportPurchaseConversion = ({ value, reference }) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'conversion', {
    send_to: GOOGLE_ADS_PURCHASE_CONVERSION,
    value: Number(value) || 0,
    currency: 'ZAR',
    transaction_id: reference,
  });
};
